var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchReceiptIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8643 26.418C26.0025 26.2837 26.2164 26.2847 26.3535 26.4209L26.3984 26.4658L26.4482 26.5049L30.5352 29.8047L30.6387 29.8877C30.8477 30.2393 30.803 30.7045 30.5039 31.0068C30.164 31.3502 29.6221 31.355 29.2764 31.0215L25.9209 27.1758L25.915 27.1689L25.8223 27.0645C25.7599 26.9803 25.7237 26.8762 25.7236 26.7666C25.7236 26.6337 25.7759 26.5086 25.8643 26.418ZM13.7246 1.73145C17.0332 1.73155 20.209 3.06002 22.5527 5.42871C24.897 7.79823 26.2168 11.0154 26.2168 14.3721C26.2167 21.3653 20.6115 27.0115 13.7246 27.0117C6.83759 27.0117 1.23155 21.3655 1.23145 14.3721C1.23145 7.37859 6.83753 1.73145 13.7246 1.73145Z",
    stroke: "black",
    strokeWidth: 2.46325
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchReceiptIcon);
export default __webpack_public_path__ + "static/media/searchReceiptIcon.9a3713f43a7991359cbc3b8e9fec9202.svg";
export { ForwardRef as ReactComponent };